<template>
    <div>
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="90">
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="提醒类型" prop="notifyType">
                        <check-tag-group
                            style="display: inline-block"
                            v-model="notifyType"
                            color="primary"
                            @on-change="changeRemindType"
                        >
                            <check-tag
                                v-for="item in notifyTypeList"
                                :name="item.id"
                                :key="item.id"
                            >
                                {{ item.text }}
                            </check-tag>
                        </check-tag-group>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="账期" prop="period">
                        <Select v-model="info.period" transfer placeholder="">
                            <Option
                                v-for="item in periodList"
                                :value="item.period"
                                :key="item.period"
                            >
                                {{ item.text }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="预览">
                        <send-bill-list
                            v-if="notifyType[0] == 'ZD'"
                            :list="billList"
                            :loading="loading"
                        />
                        <send-receipt
                            v-if="notifyType[0] == 'SJ'"
                            :list="receiptList"
                            :loading="loading"
                        />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import Dict from "_u/dict";
import { currency, getAbsStaticPath, deepCopy } from "_u/helper";

import SendBillList from "./send-bill-list";
import SendReceipt from "./send-receipt";

import { queryPeriods } from "@/api/bill";
import { billDetails, sendRemind, queryReceipt } from "@/api/tenants";
import tHistoryListVue from "./t-history-list.vue";

export default {
    inject: {
        $modal: {
            default: null,
        },
    },
    components: { SendBillList, SendReceipt },
    data() {
        return {
            loading: false,
            info: {
                cusId: "",
                period: this.row.period,
                startDate: this.row.startDate,
                endDate: this.row.endDate,
                planAmount: this.row.planAmount,
            },
            notifyType: ["ZD"],
            periodList: [],
            notifyTypeList: [],
            dict: {
                notifyType: Dict.NULL,
                billStatus: Dict.NULL,
                feeType: Dict.NULL,
            },
            billList: [],
            receiptList: [],
            // 应收金额-未收总额
            planAmount: 0,
            // 应收日期-取账单最晚的日期
            planDate: "",
        };
    },
    props: {
        row: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ruleValidate() {
            return {};
        },
    },
    watch: {
        "info.period"(val) {
            const period = this.periodList.find((v) => v.period === val);
            this.info.startDate = period.startDate;
            this.info.endDate = period.endDate;
            this.getInfoByPeriod();
        },
    },
    methods: {
        // 提醒类型发生更改
        changeRemindType(arr) {
            this.getInfoByPeriod();
        },

        // 获取数据
        getInfoByPeriod() {
            if (this.notifyType[0] === "ZD") {
                this.getPeriodList();
            } else if (this.notifyType[0] === "SJ") {
                this.getReceipt();
            }
        },

        // 获取账期的账单
        getPeriodList() {
            this.loading = true;
            billDetails({
                contractId: this.row.contractId,
                cusId: this.row.cusId,
                houseId: this.row.houseId,
                period: this.info.period,
            })
                .then((res) => {
                    if (res.data.billList) {
                        this.planAmount = 0;
                        res.data.billList.forEach((v) => {
                            const billStatus = this.dict.billStatus.get(
                                v.billStatus
                            );
                            v.billStatusText = billStatus.text;
                            v.billStatusColor = JSON.parse(
                                billStatus.remark
                            ).color;
                            v.billStatusBgc = JSON.parse(
                                billStatus.remark
                            ).background;
                            v.feeTypeText = this.dict.feeType.val(v.feeType);
                            v.price =
                                v.billStatus === "1"
                                    ? v.planAmount
                                    : v.realAmount;
                            // 应收金额为未收款账单总额
                            if (v.billStatus === "1") {
                                this.planAmount += v.planAmount - 0;
                            }
                            // 应付款日为租金的应付款日
                            if (v.feeType === "1") {
                                this.planDate = v.planDate;
                            }
                        });
                        this.billList = res.data.billList;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 获取收据
        getReceipt() {
            this.loading = true;
            console.log("receipt");
            queryReceipt({
                contractId: this.row.contractId,
                period: this.info.period,
            })
                .then((res) => {
                    const receiptList = res.data.list;
                    this.formateReceipt(receiptList);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 格式化收据列表
        formateReceipt(list) {
            list.forEach((v) => {
                const arr = JSON.parse(v.attachments || "[]");
                console.log(arr.map((el) => el.path));
                v.imgUrl = getAbsStaticPath(arr.map((el) => el.path));
                console.log(v.imgUrl);
            });
            this.receiptList = list;
        },
    },
    mounted() {
        var btns = [{ type: "default", text: "取消", name: "cancel" }];

        if (this.$can("update")) {
            btns.unshift({
                type: "primary",
                name: "confirm",
                text: "确定",
            });
        }
        this.$modal.updateBtns(btns);

        this.$modal.beforeEnter((next) => {
            Promise.all([
                Dict.get(["notify_type", "bill_status", "fee_type"]),
                queryPeriods(this.row.contractId),
            ])
                .then((args) => {
                    var [dictGroup, periods] = args;
                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name];
                    });
                    this.notifyTypeList = this.dict.notifyType.toList();

                    const periodList = [];
                    periods.data.periods.forEach((v) => {
                        periodList.push({
                            period: v.period,
                            text: `第${v.period}期(${v.startDate} 至 ${v.endDate})`,
                            startDate: v.startDate,
                            endDate: v.endDate,
                        });
                    });
                    this.periodList = periodList;

                    this.getInfoByPeriod();
                })
                .finally(() => {
                    next();
                });
        });

        // 确定
        this.$modal.onBtnClick("confirm", (next, options) => {
            const bill = {
                cusId: this.row.cusId,
                cusName: this.row.cusName,
                houseId: this.row.houseId,
                houseName: this.row.houseName,
                period: this.info.period,
                startDate: this.info.startDate,
                endDate: this.info.endDate,
                planAmount: this.planAmount,
                planDate: this.planDate,
                notifyType: this.notifyType[0],
                module: this.notifyType[0],
            };
            const receipt = {
                cusId: this.row.cusId,
                cusName: this.row.cusName,
                houseId: this.row.houseId,
                houseName: this.row.houseName,
                period: this.info.period,
                startDate: this.info.startDate,
                endDate: this.info.endDate,
                receiptNo: "",
                totalAmount: "",
                invoiceTime: "",
                notifyType: this.notifyType[0],
                module: this.notifyType[0],
            };
            let formate = {};
            let type = "success";
            if (this.notifyType[0] === "ZD") {
                formate = bill;
            } else if (this.notifyType[0] === "SJ") {
                formate = receipt;
                if (this.receiptList.length === 0) {
                    type = "failReceipt";
                } else {
                    type = "receipt";
                }
            }

            // 默认成功提醒
            if (type === "success") {
                sendRemind(formate)
                    .then((res) => {
                        this.$Message.success("成功发送提醒");
                    })
                    .catch((err) => {
                        options.closeModal = false;
                    })
                    .finally(() => {
                        next();
                    });
            }
            // 收据——无值
            else if (type === "failReceipt") {
                this.$Message.error("收据提醒发送失败");
                options.closeModal = false;
                next();
            }
            // 收据-有值-发生多条提醒
            else if (type === "receipt") {
                const list = [];
                let i = 0;
                let len = this.receiptList.length;
                this.receiptList.forEach((v) => {
                    const obj = deepCopy(receipt);
                    obj.receiptNo = v.receiptNo;
                    obj.totalAmount = v.totalAmount;
                    obj.invoiceTime = v.invoiceTime;
                    sendRemind(obj)
                        .then((res) => {
                            i++;
                            if (i === len) {
                                this.$Message.success("成功发送提醒");
                                next();
                            }
                        })
                        .catch((err) => {
                            options.closeModal = false;
                        })
                        .finally(() => {
                            next();
                        });
                });
            }
        });
    },
};
</script>
